<div class="d-flex h-100 p-3 pack align-items-center {{ pack.classColor }}">
        <div class="my-auto ml-auto">
            <span class="pack-title">{{ pack.name | translate }}</span>
        </div>
        <div class="my-auto">
            <a [routerLink]="['/novo-plano']">
                <span class="d-inline-block align-middle mx-2">
                    <i class="icon-edponline-Bop-073 rotate-270 icon-size"  aria-hidden="true"></i>
                </span>
            </a>
        </div>
        <div class="my-auto mr-auto">
            <span class="d-none d-lg-inline-block pack-icon">
                <i class="icon-edponline-Bop-086"  aria-hidden="true"></i>
                <i class="icon-edponline-Bop-002"  aria-hidden="true"></i>
                <i class="icon-edponline-Bop-052" [ngClass]="{'inactive': !contract?.HasPack?.full}"  aria-hidden="true"></i>
                <i class="icon-edponline-Bop-023" [ngClass]="{'inactive': !contract?.HasPack?.full_sm}"  aria-hidden="true"></i>
            </span>
        </div>
</div>